module.exports = __webpack_public_path__ + "img/abo3.e9f303cf.jpg";